'use client';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ReactPaginate from 'react-paginate';
import { DefaultPlayer as video } from 'react-html5video';

import { FaArrowLeft, FaArrowRight, FaPlay } from 'react-icons/fa';
import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';
import { Helmet } from 'react-helmet-async';
import { getVideoGallery } from '../service/service';
export default function VideoGalerea() {
	const [menu, setMenu] = useState([]);
	// import { useContext } from 'react'
	//import { SearchContext } from './Contexts/Context'
	// .filter(news => news[1].geo.title.includes(search))
	const { search } = useContext(SearchContext);
	const { language } = useContext(SearchContext);
	const [videoGallery, setVideoGallery] = useState([]);
	const [selectedVideo, setSelectedVideo] = useState(null);
	useEffect(() => {
		const link = 'https://khulo.gov.ge/api/site_menu1.php';
		fetch(link)
			.then(response => response.json())
			.then(data => {
				// console.log('data.menu',data.menu)
				setMenu(data.menu);

				//  console.log('menu', menu)

				//  console.log('object entries', Object.entries(menu))

				Object.entries(menu).map(item => {
					if (item[1].level == 1) {
						//console.log('entries item', item[1].name_eng , item[1].level)
					}
				});
			});
	}, []);
	const [videos, setVideos] = useState({});
	useEffect(() => {
		const link = 'https://khulo.gov.ge/api/video.php';
		fetch(link)
			.then(response => response.json())
			.then(data => {
				setVideos(data);
				// console.log(data)

				// console.log(data)
				// console.log('news', news)

				// console.log('object keys menu', Object.keys(menu))
				// console.log('object entries news', Object.entries(data))
			});
		// console.log('news', news)
		// console.log('news 0', news[0])
	}, []);
	const presscenterList = Object.entries(menu).length
		? Object.entries(menu).map((item, index) => {
				if (item[1].level == 1 && item[1].name_geo.includes('პრესცენტრი')) {
					return Object.entries(menu).map((qveItem, index) => {
						if (qveItem[1].parent_id == item[1].cat_id) {
							const windoww = window.location.pathname;
							const result = windoww.split('/').pop();
							const slugg = qveItem[1].slug;
							return (
								<span key={index} className={result === slugg ? 'active' : ''}>
									<Link to={`/${qveItem[1].slug}`}>
										{language == 1 ? qveItem[1].name_geo : ''}
										{language == 2 ? qveItem[1].name_eng : ''}
									</Link>
								</span>
							);
						}
					});
				}
		  })
		: 'LOADING';

	//pagination
	const [pageNumber, setPageNumber] = useState(0);
	const usersPerPage = 6;
	const pagesVisited = pageNumber * usersPerPage;
	const pageCount = Math.ceil(videos.length / usersPerPage);
	const pageChange = ({ selected }) => {
		setPageNumber(selected);
	};

	const newsList = videos.length
		? [...Object.entries(videos)]
				.reverse()
				.filter(news => news[1].title_geo.includes(search))
				.slice(pagesVisited, pagesVisited + usersPerPage)
				.map((news, index) => {
					// console.log(news)
					const source = news[1].youtube_link.includes('&')
						? news[1].youtube_link
								.replace('youtube.com/watch?v=', 'youtube.com/embed/')
								.slice(0, news[1].youtube_link.indexOf('&') - 2)
						: news[1].youtube_link.replace(
								'youtube.com/watch?v=',
								'youtube.com/embed/'
						  );

					return (
						<a href={news[1].youtube_link} target='blank' key={index}>
							{' '}
							<div className='landing-items-container-infos'>
								<div className='video-wrapper'>
									<div className='new-image-wrapper'>
										<iframe
											src={source}
											controls
											id='video'
											title={news[1].title_geo}
										></iframe>
									</div>
								</div>
								<div>
									<span className='time'>
										{language == 1 ? news[1].date_geo : ''}
										{language == 2 ? news[1].date_eng : ''}
									</span>
									<span className='header'>
										{language == 1 ? news[1].title_geo : ''}
										{language == 2 ? news[1].title_eng : ''}
									</span>
									<span className='vrclad'>
										<Link to={`/news/${news.id}`}>
											{language == 1 ? ' ვრცლად' : ''}
											{language == 2 ? ' See more' : ''}
										</Link>
									</span>
								</div>
							</div>
						</a>
					);
				})
		: '';

		

const handleClick = (video = null) => {
	setSelectedVideo(video);
}		

// console.log(selectedVideo)

useEffect(() => {
	(async () => {
		const data = await getVideoGallery();
		setVideoGallery(data);
	})();
}, []);

 const VievGallery = ({title, video, description, image}) => {
	const isSelected = selectedVideo === video;
	
	return (
		<>	
		<div className="col-md-4 col-sm-6 col-xs-12 anbani_in">
			<div className="visit_card" onClick={() => handleClick(video)}>
			  <div className="card" style={{ width: "100%", marginBottom: "1em", marginTop: "1em" }}>
				 <img src={image} className="card-img-top" data-bs-toggle="modal" data-bs-target="#myModal" alt="..." />
					<div className="card-body" >
							 <br />
						<h5 className="card-title col-12 mt-2">{title.slice(0, 58)}</h5>
					</div>
				</div>
            </div>
		</div>
		   <div className={`modal fade ${isSelected ? 'show' : ""}`} onClick={() => handleClick(null)} id={`modal-${video.slice(32)}`} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
     <div className="modal-dialog" role="document">
       <div className="modal-content">
         <div className="modal-body">
          <button type="button" className="btn-close" onClick={() => handleClick(null)} aria-label="Close"></button>        
       
   <div className="ratio ratio-16x9">
	<iframe src={`https://www.youtube.com/embed/${video.slice(32)}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
   </div>
   <div className="text-conten mt-1">
    <div className="text-content-title">{title}</div>
    <div className="text-conten-border"></div>
    <div className="text-conten-center" > <p dangerouslySetInnerHTML={{ __html: description ? description : "..." }}></p></div>
 </div>
         </div>
       </div>
     </div>
   </div> 
   {isSelected ? <div className="modal-backdrop show" onClick={() => handleClick(null)}></div> : ''}
		</>
		)
 }		

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px'>
				<header>
					<span className='big'>
						{' '}
						{language == 1 ? ' პრესცენტრი' : ''}
						{language == 2 ? ' PRESS CENTER' : ''}
					</span>
					<span>
						{language == 1 ? ' ვიდეოგალერეა' : ''}
						{language == 2 ? ' VIDEO GALLERY' : ''}
					</span>
					<Helmet>
						<title>
							{language == 1 ? ' ვიდეოგალერეა' : ''}
							{language == 2 ? ' VIDEO GALLERY' : ''}
						</title>
					</Helmet>
				</header>
				<div>
					<div className=' videos'>
						<div className="row anbani_out">
							{videoGallery?.length > 0 ? (
								videoGallery?.map((item, index) => (
									<VievGallery key={index} video={item.video_url} title={item.title} description={item.description} image={item.image} />
								))
							) : (
								<div>No videos available</div>
							)}
						</div>
					</div>
					{/* <div className='presscenter-info'>{presscenterList}</div> */}
				</div>

				{videos.length > 0 && (
					<div className='pagination'>
						<div className='left-space'></div>
						<ReactPaginate
							previousLabel={<FaArrowLeft />}
							nextLabel={<FaArrowRight />}
							pageCount={pageCount}
							onPageChange={pageChange}
							containerClassName={'paginationButtons'}
							previousLinkClassName={'previusButton'}
							nextLinkClassName={'nextButton'}
							disabledClassName={'disabledButton'}
							activeClassName={'activeButton'}
							onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
						/>
					</div>
				)}
			</div>
		</motion.div>
	);
}
